import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentGet } from '../../services';

export const fetchDocumentGet = createAsyncThunk(
    'documentGet/fetchDocumentGet',
    async ({ id }) => {
        const response = await DocumentGet(id)
        return response.result
    }
);

const documentGetSlice = createSlice({
    name: 'documentGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentGetSlice.reducer;
